import React, { useRef, useState } from "react";
import { AutoComplete } from "antd";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import FilterDeadlinesChips from "./filterDeadlinesChips";

const CounterpartFilter = ({filterCounter, setFilterCounter, selectedCounterparts, setSelectedCounterparts}) => {

  const [counterpartsOptions, setCounterpartsOptions] = useState([]);
  const [counterpartValue, setCounterpartValue] = useState("");
  const reconcilableDeadlines = useSelector(state => state.reconciliation.operations.reconcilableDeadlines);

  const refCounterpart = useRef();

  useEffect(() => {
    let counterparts = [];

    const counterpartsRaw = reconcilableDeadlines?.filteredDeadlines?.map(c => {
      return c.counterpart?.description;
    });
    const uniqCounterparts = [...new Set(counterpartsRaw)];

    for (const counterpart of uniqCounterparts) {
      if (counterpart !== undefined) {
        counterparts.push({
          value: counterpart
        });
      }
    }
    setCounterpartsOptions(counterparts);
  }, [reconcilableDeadlines]);

  const onChangeCounterpart = (e, isToAddInChips) => {
    setCounterpartValue(e);

    if (e && isToAddInChips) {
      if (selectedCounterparts.length === 0) {
        setFilterCounter(filterCounter + 1);
      }
      if (!selectedCounterparts.includes(e)) {
        const selectedCountCopy = [...selectedCounterparts];
        selectedCountCopy.push(e);
        setCounterpartValue("");
        setSelectedCounterparts(selectedCountCopy);
      }
    }
  };

  const removeCounterparts = index => {
    const selectedCountCopy = [...selectedCounterparts];
    selectedCountCopy.splice(index, 1);
    setSelectedCounterparts(selectedCountCopy);
  };

  const renderCounterpartsChips = () => {
    return (
      <FilterDeadlinesChips
        selectedItems={selectedCounterparts}
        onRemoveSelectedItems={index => removeCounterparts(index)}
        key={"counterparts"}
      />
    );
  };

  return (
    <div className="document-number-filter" style={{width: "70%"}}>
      <AutoComplete
        ref={refCounterpart}
        allowClear={true}
        popoverPlacement={"bottom"}
        getPopupContainer={trigger => trigger.parentNode}
        options={counterpartsOptions}
        style={{ width: "100%" }}
        initialValue={counterpartValue}
        value={counterpartValue}
        filterOption={(inputValue, option) => {
          if (inputValue === "") return true;
          return option.value.toUpperCase().indexOf(inputValue.toUpperCase())>-1;
        }
        }
        placeholder={""}
        notFoundContent={"Nessun risultato"}
        onClear={()=> {
          onChangeCounterpart("", false);
          refCounterpart.current.focus();
        }}
        onSearch={el => {
          onChangeCounterpart(el, false);
        }}
        onSelect={ el => {
          onChangeCounterpart(el, true);
          refCounterpart.current.blur();
        }}
      />
      {renderCounterpartsChips()}
    </div>
  );
};

export default CounterpartFilter;

